import { usePermissions } from "@/util/permissions";
import { faCartShopping, faPuzzlePiece } from "@fortawesome/pro-solid-svg-icons";
import { i18n } from "../i18n";
import { commonMenuItems } from "./common";
import defaultProfile, { asyncRoute } from "./default";
import type { ConfigSection, GameProfile, Menu, ProfileCtx } from "./types";
import { MenuItem } from "./types";

const { t } = i18n.global;

const configSections: ConfigSection[] = [
  { component: "ConfSection", props: { name: "basic" } },
  { component: "ConfSection", props: { name: "worldMapSettings" } },
  { component: "ConfSection", props: { name: "extended" } },
  { component: "TableSection", props: { name: "admins" } },
];

const createMenu = (): Menu => {
  const menu = defaultProfile().menu;
  const { isAdmin } = usePermissions();
  menu[0].items.push(
    commonMenuItems.logs,
    new MenuItem(
      "mods",
      faPuzzlePiece,
      asyncRoute(() => import("../components/views/config/sevenDays/Mods.vue")),
    ),
  );
  if (isAdmin.value) {
    menu[1].items.push(
      new MenuItem(
        "tebex",
        faCartShopping,
        asyncRoute(() => import("../components/views/Tebex.vue")),
      ),
    );
  }
  return menu;
};

const join = () => {
  window.open(t("ngp/settings/section/seven_days_wiki/link"), "_blank", "noopener,noreferrer");
};

export default (_ctx: ProfileCtx): Partial<GameProfile> => ({
  menu: createMenu(),
  configSections,
  join: {
    buttonTextKey: "ngp/settings/section/seven_days_wiki",
    joinFn: join,
  },
});
